import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Menu, User } from "lucide-react";
import { T } from "@/lib/testIds";
import { formatRank } from "@/lib/api";
import { useMe } from "@/lib/useMe";

export default function TopHeader({ title = "Manager Dashboard" }) {
  const nav = useNavigate();
  const { data } = useMe();
  const mgr = data?.manager;

  return (
    <header className="sticky top-0 z-30 bg-totem-bg/85 backdrop-blur-md border-b border-totem-border/60">
      <div className="mx-auto max-w-md px-4 py-3 flex items-center gap-3">
        <button
          data-testid={T.topMenuButton}
          onClick={() => nav("/profile")}
          className="p-2 -ml-2 text-totem-text hover:text-totem-green transition-colors"
          aria-label="Menu"
        >
          <Menu size={22} strokeWidth={2} />
        </button>
        <h1 className="display-heading text-totem-green text-[18px] leading-tight uppercase tracking-tight flex-1">
          {title}
        </h1>
        {mgr ? (
          <Link
            to="/profile"
            data-testid={T.topProfileButton}
            className="flex items-center gap-3 rounded-full bg-totem-surfaceElev border border-totem-border team-accent-border pl-3 pr-2 py-1.5"
          >
            <div className="text-right leading-tight">
              <div
                data-testid={T.topManagerRank}
                className="mono text-[10px] uppercase text-totem-textDim"
              >
                OR: {formatRank(mgr.summary_overall_rank)}
              </div>
              <div
                data-testid={T.topManagerPoints}
                className="mono text-[11px] text-totem-green"
              >
                {mgr.summary_overall_points ?? 0} pts
              </div>
            </div>
            <span
              className="grid place-items-center w-7 h-7 rounded-full text-totem-bg"
              style={{ background: "var(--team-primary)" }}
            >
              <User size={14} strokeWidth={2.5} />
            </span>
          </Link>
        ) : (
          <div className="w-8" />
        )}
      </div>
    </header>
  );
}
